import { DropdownMenuRadioGroup, DropdownMenuRadioItem } from 'shared/components/ui/dropdown-menu'
import { LANGUAGE_NAMES, LANGUAGES } from 'shared/lib/i18n'
import { Flag } from './flag'
import { useLanguage } from './use-language'

/** The languages as radio items of a dropdown menu, each named in itself. */
export function LanguageRadioItems() {
	const { lang, choose } = useLanguage()

	return (
		<DropdownMenuRadioGroup value={lang} onValueChange={choose}>
			{LANGUAGES.map((code) => (
				<DropdownMenuRadioItem key={code} value={code} data-testid={`language-${code}`}>
					<Flag lang={code} className='size-auto h-4 rounded-xs' />
					{LANGUAGE_NAMES[code]}
				</DropdownMenuRadioItem>
			))}
		</DropdownMenuRadioGroup>
	)
}
